import qrcode from 'qrcode-generator';

/** SVG do QR Code (gerado localmente; o conteúdo nunca sai do aparelho para gerar a imagem). */
export function qrSvg(text) {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  return qr.createSvgTag({ cellSize: 6, margin: 2, scalable: true, alt: 'QR Code da autorização' });
}
